(function () {
    "use strict";

    window.__productCardSwatchesArrowEnhanced = true;

    const SWATCH_SELECTOR = ".product-card-swatches";
    function getMaxSwatchScrollLeft(swatchesContainer) {
        const swatches = swatchesContainer.querySelectorAll(".product-card-swatch");
        const firstSwatch = swatches[0];
        const lastSwatch = swatches[swatches.length - 1];

        if (!firstSwatch || !lastSwatch) return 0;

        return Math.max(
            0,
            Math.ceil(
                lastSwatch.offsetLeft -
                firstSwatch.offsetLeft +
                lastSwatch.offsetWidth -
                swatchesContainer.clientWidth
            )
        );
    }

    function clampSwatchScroll(swatchesContainer) {
        const maxScrollLeft = getMaxSwatchScrollLeft(swatchesContainer);

        if (swatchesContainer.scrollLeft > maxScrollLeft) {
            swatchesContainer.scrollLeft = maxScrollLeft;
        }

        return maxScrollLeft;
    }

    function getSwatchMetrics(swatchesContainer) {
        const swatches = swatchesContainer.querySelectorAll(".product-card-swatch");
        const firstSwatch = swatches[0];

        if (!firstSwatch) {
            return {
                swatches,
                swatchStep: 0,
                visibleCount: 0,
            };
        }

        const styles = window.getComputedStyle(swatchesContainer);
        const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
        const swatchStep = firstSwatch.offsetWidth + gap;
        const visibleCount = swatchStep
            ? Math.max(1, Math.floor((swatchesContainer.clientWidth + gap) / swatchStep))
            : 1;

        return {
            swatches,
            swatchStep,
            visibleCount,
        };
    }

    function getNearestSwatchIndex(swatchesContainer, swatches) {
        if (!swatches.length) return 0;

        const currentScroll = swatchesContainer.scrollLeft;
        const firstOffset = swatches[0].offsetLeft;
        let nearestIndex = 0;
        let smallestDistance = Infinity;

        swatches.forEach((swatch, index) => {
            const swatchOffset = swatch.offsetLeft - firstOffset;
            const distance = Math.abs(swatchOffset - currentScroll);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                nearestIndex = index;
            }
        });

        return nearestIndex;
    }

    function bindTouchBounds(swatchesContainer, updateButtons) {
        let startX = 0;
        let startY = 0;
        let startScrollLeft = 0;
        let scrollTimer;

        function clampSoon() {
            window.requestAnimationFrame(() => {
                clampSwatchScroll(swatchesContainer);
                updateButtons();
            });

            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => {
                clampSwatchScroll(swatchesContainer);
                updateButtons();
            }, 120);
        }

        swatchesContainer.addEventListener(
            'touchstart',
            (event) => {
                const touch = event.touches && event.touches[0];
                if (!touch) return;

                startX = touch.clientX;
                startY = touch.clientY;
                startScrollLeft = swatchesContainer.scrollLeft;
            },
            { passive: true }
        );

        swatchesContainer.addEventListener(
            'touchmove',
            (event) => {
                const touch = event.touches && event.touches[0];
                if (!touch) return;

                const totalX = touch.clientX - startX;
                const totalY = touch.clientY - startY;
                const isHorizontalSwipe = Math.abs(totalX) > Math.abs(totalY);
                const maxScrollLeft = getMaxSwatchScrollLeft(swatchesContainer);

                if (isHorizontalSwipe) {
                    event.preventDefault();
                    swatchesContainer.scrollLeft = Math.max(
                        0,
                        Math.min(startScrollLeft - totalX, maxScrollLeft)
                    );
                }

                clampSoon();
            },
            { passive: false }
        );

        swatchesContainer.addEventListener('touchend', clampSoon, { passive: true });
        swatchesContainer.addEventListener('touchcancel', clampSoon, { passive: true });
    }

    /**
     * Enhance a single swatch container:
     * wrap in .product-card-swatches-wrapper, add arrows, bind events.
     */
    function enhanceSwatchContainer(swatchesContainer) {
        if (!swatchesContainer) return;

        // Avoid initializing the same container multiple times
        if (swatchesContainer.dataset.swatchesEnhanced === "1") return;
        swatchesContainer.dataset.swatchesEnhanced = "1";

        // Ensure wrapper exists
        let wrapper = swatchesContainer.closest(".product-card-swatches-wrapper");
        if (!wrapper) {
            wrapper = document.createElement("div");
            wrapper.className = "product-card-swatches-wrapper";
            if (swatchesContainer.parentNode) {
                swatchesContainer.parentNode.insertBefore(wrapper, swatchesContainer);
                wrapper.appendChild(swatchesContainer);
            }
        }

        // Find or create arrows
        let leftBtn = wrapper.querySelector(".swatches-scroll-btn-left");
        let rightBtn = wrapper.querySelector(".swatches-scroll-btn-right");

        if (!leftBtn) {
            leftBtn = document.createElement("button");
            leftBtn.type = "button";
            leftBtn.className = "swatches-scroll-btn swatches-scroll-btn-left";
            leftBtn.setAttribute("aria-label", "Scroll left");
            leftBtn.innerHTML =
                '<svg role="img" aria-label="bookend-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="39" viewBox="0 0 24 39" fill="none">' +
                '<rect width="24" height="39" transform="translate(24 39)" fill="#FDFAF8"></rect>' +
                '<path d="M16.8761 26.7353C16.4632 27.1548 15.786 27.1524 15.376 26.7301C14.9809 26.3231 14.9809 25.6758 15.376 25.2689L20.3003 20.1966C20.6769 19.8086 20.6769 19.1914 20.3003 18.8034L15.3761 13.7313C14.9809 13.3242 14.9809 12.6768 15.3761 12.2698C15.7861 11.8475 16.4632 11.845 16.8762 12.2644L22.6182 18.0944C23.3848 18.8727 23.385 20.1222 22.6187 20.9007L16.8761 26.7353Z" fill="#283455"></path>' +
                "</svg>";
            wrapper.appendChild(leftBtn);
        }

        if (!rightBtn) {
            rightBtn = document.createElement("button");
            rightBtn.type = "button";
            rightBtn.className = "swatches-scroll-btn swatches-scroll-btn-right";
            rightBtn.setAttribute("aria-label", "Scroll right");
            rightBtn.innerHTML =
                '<svg role="img" aria-label="bookend-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="39" viewBox="0 0 24 39" fill="none">' +
                '<rect width="24" height="39" transform="translate(24 39)" fill="#FDFAF8"></rect>' +
                '<path d="M16.8761 26.7353C16.4632 27.1548 15.786 27.1524 15.376 26.7301C14.9809 26.3231 14.9809 25.6758 15.376 25.2689L20.3003 20.1966C20.6769 19.8086 20.6769 19.1914 20.3003 18.8034L15.3761 13.7313C14.9809 13.3242 14.9809 12.6768 15.3761 12.2698C15.7861 11.8475 16.4632 11.845 16.8762 12.2644L22.6182 18.0944C23.3848 18.8727 23.385 20.1222 22.6187 20.9007L16.8761 26.7353Z" fill="#283455"></path>' +
                "</svg>";
            wrapper.appendChild(rightBtn);
        }

        const totalSwatches = swatchesContainer.querySelectorAll(
            ".product-card-swatch"
        ).length;

        function scroll(direction) {
            const { swatches, visibleCount } = getSwatchMetrics(swatchesContainer);
            const maxScrollLeft = getMaxSwatchScrollLeft(swatchesContainer);

            if (!swatches.length || !visibleCount) return;

            const firstOffset = swatches[0].offsetLeft;
            const maxStartIndex = Math.max(0, swatches.length - visibleCount);
            const currentIndex =
                swatchesContainer.scrollLeft >= maxScrollLeft - 1
                    ? maxStartIndex
                    : getNearestSwatchIndex(swatchesContainer, swatches);
            const directionStep = direction === "left" ? -visibleCount : visibleCount;
            const targetIndex = Math.max(
                0,
                Math.min(currentIndex + directionStep, maxStartIndex)
            );
            const targetScroll = Math.max(
                0,
                Math.min(swatches[targetIndex].offsetLeft - firstOffset, maxScrollLeft)
            );

            try {
                swatchesContainer.scrollTo({ left: targetScroll, behavior: "smooth" });
            } catch (e) {
                swatchesContainer.scrollLeft = targetScroll;
            }
        }

        // >>> UPDATED FUNCTION <<<
        function updateButtons() {
            const maxScrollLeft = clampSwatchScroll(swatchesContainer);
            const currentScroll = swatchesContainer.scrollLeft;
            const hasOverflow = maxScrollLeft > 1;

            // Not enough swatches OR no horizontal overflow → hide arrows
            if (totalSwatches <= 1 || !hasOverflow) {
                wrapper.classList.add("swatches-static");
                leftBtn.classList.remove("show", "disabled");
                rightBtn.classList.remove("show", "disabled");
                return;
            }

            // There IS overflow → show both arrows
            wrapper.classList.remove("swatches-static");
            leftBtn.classList.add("show");
            rightBtn.classList.add("show");

            // Start with both enabled
            leftBtn.classList.remove("disabled");
            rightBtn.classList.remove("disabled");

            // At far left → disable left arrow
            if (currentScroll <= 1) {
                leftBtn.classList.add("disabled");
            }

            // At far right → disable right arrow
            if (currentScroll >= maxScrollLeft - 1) {
                rightBtn.classList.add("disabled");
            }
        }

        // Expose updater for resize
        swatchesContainer._updateSwatchButtons = updateButtons;

        // Scroll listener (once)
        swatchesContainer.addEventListener("scroll", updateButtons, {
            passive: true,
        });
        swatchesContainer.addEventListener("touchend", updateButtons, {
            passive: true,
        });
        bindTouchBounds(swatchesContainer, updateButtons);

        // >>> UPDATED LEFT CLICK HANDLER <<<
        leftBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!leftBtn.classList.contains("disabled")) {
                scroll("left");
            }
        });

        rightBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!rightBtn.classList.contains("disabled")) {
                scroll("right");
            }
        });

        // Initial state
        updateButtons();
    }

    /**
     * Enhance all swatch containers inside a given root.
     */
    function enhanceAllSwatches(root) {
        const swatches = (root || document).querySelectorAll(SWATCH_SELECTOR);
        if (!swatches.length) return;
        swatches.forEach(enhanceSwatchContainer);
    }

    // Initial run
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            enhanceAllSwatches(document);
        });
    } else {
        enhanceAllSwatches(document);
    }

    // Debounced resize → reuse stored update function
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            document.querySelectorAll(SWATCH_SELECTOR).forEach((container) => {
                if (typeof container._updateSwatchButtons === "function") {
                    container._updateSwatchButtons();
                }
            });
        }, 200);
    });

    // MutationObserver → only process newly added swatch nodes
    if (typeof MutationObserver !== "undefined") {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (!mutation.addedNodes || !mutation.addedNodes.length) return;

                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return; // element only

                    // Node itself is a swatch container
                    if (node.matches && node.matches(SWATCH_SELECTOR)) {
                        enhanceSwatchContainer(node);
                        return;
                    }

                    // Or it contains swatch containers
                    if (node.querySelectorAll) {
                        const nested = node.querySelectorAll(SWATCH_SELECTOR);
                        nested.forEach(enhanceSwatchContainer);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
})();
